"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var shared_1 = require("@formily/shared");
var useForm_1 = require("../hooks/useForm");
var context_1 = __importDefault(require("../context"));
exports.Form = function (props) {
    if (props === void 0) { props = {}; }
    var form = useForm_1.useForm(props);
    return (react_1.default.createElement(context_1.default.Provider, { value: form }, shared_1.isFn(props.children)
        ? props.children(form)
        : react_1.default.Children.map(props.children, function (node) {
            return react_1.default.cloneElement(node);
        })));
};
exports.Form.displayName = 'ReactInternalForm';



//////////////////
// WEBPACK FOOTER
// ./node_modules/@formily/react/lib/components/Form.js
// module id = 4647
// module chunks = 0